<div class="blank_receipt-page" @fadeInAnimation>
  <div class="blank_receipt-page-title">
    <span class="title" [innerHTML]="'BLANK_RECEIPT.TITLE' | translate"></span>
  </div>
  <div>
    <div class="blank_receipt-page-search">
      <app-blank-receipt-form
        [isSaving]="isSaving"
        [receiptTypes]="globalTypes"
        [shipTos]="shipTos"
        [customers]="customers"
        [showSelectCustomers]="isSuperUser"
        (createBlankReceipts)="createBlankReceipts($event)"
        (customerSelected)="getsShipTosForCustomer($event)"
      ></app-blank-receipt-form>
    </div>
  </div>
</div>
